import { Emit, Options, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { FormMixin } from "@/mixins/form/FormMixin";
import { onBeforeRouteLeave, Router } from "vue-router";

@Options({})
export class FormUpdateMixin extends mixins(FormMixin) {
  protected resource?: string;
  protected getItemAction: any;
  protected updateAction: any;
  protected success: any;

  protected onSubmit(item: any): void {
    this.updateAction({
      resource: this.resource,
      id: item.id,
      data: item,
    });
  }

  @Watch("$route", { immediate: true, deep: true })
  protected routeChanged(router: Router) {
    if (this.$route.params.id) {
      this.getItemAction({
        resource: this.resource,
        id: this.$route.params.id,
      });
    }
  }
}
